import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.264 8.642c1.837 2.223 2.254 5.338 1.071 7.987a7.45 7.45 0 0 1-2.486 3.044c2.394.86 4.504 2.518 5.987 4.778a1 1 0 0 1-1.672 1.098c-1.815-2.767-4.727-4.441-7.85-4.544l-.383-.008q-.112.003-.223.003a1 1 0 0 1 0-2c2.057 0 3.932-1.24 4.8-3.186.874-1.957.566-4.262-.786-5.897-1.341-1.623-3.464-2.289-5.443-1.713a1 1 0 0 1-.558-1.92c2.748-.8 5.695.124 7.543 2.358M11.5 6a7.5 7.5 0 0 1 3.918 13.897c2.158.908 4.052 2.476 5.418 4.553a1 1 0 0 1-1.671 1.099C17.287 22.692 14.24 20.999 11 21s-6.287 1.692-8.164 4.55a1 1 0 1 1-1.672-1.1c1.497-2.276 3.629-3.941 6.048-4.797A7.5 7.5 0 0 1 11.5 6M6 13.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconUsers = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconUsers);
export default Memo;
